import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=723509cd&scoped=true&"
import script from "./Seminar.vue?vue&type=script&lang=js&"
export * from "./Seminar.vue?vue&type=script&lang=js&"
import style0 from "./Seminar.vue?vue&type=style&index=0&id=723509cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723509cd",
  null
  
)

export default component.exports